import axios from 'axios';

const Axios = function () {
    let axiosInstance = undefined;

    const getInstance = function () {
        if (axiosInstance === undefined) {
            axiosInstance = axios.create({
                baseURL: process.env.NODE_ENV === 'production' ? 'https://us-central1-debqzone.cloudfunctions.net/' : 'http://localhost:5000/debqzone/us-central1/',
                timeout: 60000,
            });
        }
        return axiosInstance;
    }

    return {
        getInstance: getInstance
    }
}();
export default Axios;



